import { cva } from "class-variance-authority";

const badge = cva(["badge", "badge-primary", "badge-outline"], {
  variants: {
    size: {
      xs: "badge-xs",
      sm: "badge-sm",
      md: "badge-md",
      lg: "badge-lg",
    },
    type: {
      primary: "badge-primary",
      success: "badge-success",
      danger: "badge-danger",
      warning: "badge-warning",
      info: "badge-info",
      dark: "badge-dark",
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "xs" | "sm" | "md" | "lg";
  type?: "primary" | "success" | "danger" | "warning" | "info" | "dark";
}

export function Badge({
  size = "sm",
  type = "primary",
  className,
  ...props
}: BadgeProps) {
  return <div className={badge({ size, type, className })} {...props} />;
}
